// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3Dtzb","empty":"ModalGraph_empty__2OMri"};